const CRM_MISSING_SETUP_CODES = new Set(['42P01', 'PGRST202', 'PGRST205']);

export function getCrmSetupMessage() {
  return 'Faltan migraciones CRM en Supabase. Ejecuta 20260321_crm_master_entities.sql, 20260321_crm_workflow_core.sql, 20260321_crm_commercial_reporting.sql, 20260322_crm_projects_module.sql, 20260322_crm_ticket_budget_and_project_stage_rules.sql, 20260322_crm_project_work_items_and_task_assignments.sql, 20260420_crm_meeting_topics_project_link.sql, 20260421_crm_trello_integration.sql, 20260421_crm_trello_scope_and_card_sync.sql, 20260421_crm_trello_scope_board_clients.sql y 20260421_crm_trello_scope_id_defaults_fix.sql. Si ya las corriste, espera unos segundos y refresca.';
}

export function isCrmSetupError(error) {
  const code = String(error?.code || error?.error?.code || '').toUpperCase();
  const status = Number(error?.status || error?.error?.status || 0);
  const message = [error?.message, error?.details, error?.hint]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();

  if (CRM_MISSING_SETUP_CODES.has(code)) return true;
  if (status === 404 && message.includes('crm_')) return true;
  if (message.includes('could not find the table') && message.includes('crm_')) return true;
  if (message.includes('could not find the function') && message.includes('crm_')) return true;
  if (message.includes('schema cache') && message.includes('crm_')) return true;
  if (message.includes('could not find the') && message.includes('column of') && message.includes('crm_')) return true;
  if (message.includes('relation "public.crm_')) return true;
  if (message.includes('column crm_') && message.includes('does not exist')) return true;
  if (message.includes('column public.crm_') && message.includes('does not exist')) return true;

  return false;
}

export function normalizeCrmError(error, fallbackMessage = 'Ocurrio un error en el CRM') {
  if (isCrmSetupError(error)) {
    // El detalle real va al final: este mensaje también salta por bugs de código
    // (p. ej. ordenar por una columna inexistente) y sin el detalle no se distingue.
    const detail = String(error?.message || error?.error?.message || '').trim();
    return new Error(detail ? `${getCrmSetupMessage()} Detalle: ${detail}` : getCrmSetupMessage());
  }

  if (error instanceof Error) {
    return error;
  }

  return new Error(error?.message || fallbackMessage);
}

export function getCrmErrorMessage(error, fallbackMessage = 'Ocurrio un error en el CRM') {
  return normalizeCrmError(error, fallbackMessage).message || fallbackMessage;
}
